import React, { useState, useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";

import { useParams, useLocation } from "react-router-dom";
import {
  Radio,
  Divider,
  Form,
  Input,
  message,
  Button,
  TimePicker,
  DatePicker,
  Select,
  Space,
  Modal,
} from "antd";

import "./candidateProfile.scss";
import editIcon from "../../assets/pencil.png";
import StackChart from "../StackChart";
import useQSetStore from "../../store/qset.store";
import { SUPPORTED_LOCATION } from "../../helper/categoryconstants";
import { reasonForLeavingFilter } from "../../helper/filterconstants";

export default function QSETCandidateProfile() {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(
    "Are you sure you want to save your changes?",
  );
  const [submittedValues, setSubmittedValues] = useState(null);

  const [currentView, setCurrentView] = useState("profile");
  const [isEditMode, setIsEditMode] = useState(false);
  const [haveOtherOffer, setOffersGot] = useState(false);
  const [moreSourcingDetails, setSourcingDetails] = useState("Internal Team");
  const { myApplication, myResume, myJdArray } = useQSetStore();
  const jdID = myApplication.qhcompanyjid;
  const resumeID = myApplication.qhrid;

  const [formKey, setFormKey] = useState(1);
  const [isRequired, setIsRequired] = useState(true);
  var value = jdID;

  useEffect(() => {}, []);

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  function getRequirementType() {
    if (myJdArray?.[0]?.JDProject?.ReqType == "customer_project") {
      if (myJdArray?.[0]?.JDClient?.ClientJobType == "TP") {
        return true;
      }
    }
    return false;
  }

  function getTimeNow() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const currentDate = date + "-" + month + "-" + year;
    return currentDate;
  }

  const handleFormSubmit = (values) => {
    setSubmittedValues(values);
    setOpenConfirm(true);
  };

  const handleOffer = (e) => {
    if (e.target.value == "No Offer") {
      setOffersGot(false);
    } else if (e.target.value == "In Pipeline") {
      setOffersGot(true);
    } else {
      setOffersGot(true);
    }
  };

  const handleSource = (e) => {
    setSourcingDetails(e.target.value);
  };

  const handleFormSubmitError = (values) => {
    message.success("Something is wrong. No JDID");
    setCurrentView("assignment");
    setIsEditMode(false);
  };

  const appvalues = {
    name: myResume?.personaldetail.name,
    email: myResume?.personaldetail.email,
    mobile: myResume?.personaldetail.mobile,
    score: myApplication?.resumescore.score,
    skills: myApplication?.resumestatus.tags,
    payroll: myApplication?.newemploymentdetails.payroll,
    candidatestatus: myApplication?.candidatestatus.status,
    appliedbefore: myApplication?.newemploymentdetails.appliedbefore,
    interviewbefore: myApplication?.newemploymentdetails.interviewgiven,
    alreadygotcall: myApplication?.newemploymentdetails.alreadygotcall,
    currentlocation: myApplication?.newemploymentdetails.currentlocation,
    preferredlocation: myApplication?.newemploymentdetails.preferredlocation,
    locationchangereason:
      myApplication?.newemploymentdetails.locationchangereason,
    maxdegree: myResume?.educationaldetail.maxdegree,
    stream: myResume?.educationaldetail.stream,
    college: myResume?.educationaldetail.college,
    percentage: myResume?.educationaldetail.percentage,
    passoutyear: myResume?.educationaldetail.passoutyear,
    designation: myResume?.employmentdetails.designation,
    totalexp: myApplication?.newemploymentdetails.totalexp,
    relevantexperience: myApplication?.newemploymentdetails.relevantexp,
    currentcompany: myResume?.employmentdetails.currentcompany,
    noticeperiod:
      myResume?.employmentdetails.noticeperiod.officialnp == 1024
        ? ""
        : myResume?.employmentdetails.noticeperiod.officialnp,
    negotiablenoticeperiod:
      myResume?.employmentdetails.noticeperiod.negotiableto == 1024
        ? ""
        : myResume?.employmentdetails.noticeperiod.negotiableto,
    lwd: myResume?.employmentdetails.noticeperiod.lwd,
    reason: myResume?.employmentdetails.noticeperiod.reason,
    jobcontinuity: myResume?.employmentdetails.jobcontinuity,
    notworkingreason: myResume?.employmentdetails.notworkingreason,
    currentctc: myResume?.employmentdetails.currentctc.totalctc,
    ectc: myApplication?.newemploymentdetails.ectc?.totalctc,
    offeredctc: myApplication?.newemploymentdetails.octc?.totalctc,
    doj: myApplication?.newemploymentdetails.finaldoj,
    softskills: myApplication?.newemploymentdetails.softskills,
    ectcoptions: myApplication?.newemploymentdetails.ectcoptions,
    ctcremarks: myApplication?.newemploymentdetails.ctcremarks,
    otheroffer: myResume?.offerdetails.otheroffer,
    offercompanytype: myResume?.offerdetails.offercompanytype,
    offerctc: myResume?.offerdetails.offerctc,
    offerlocations: myResume?.offerdetails.offerlocations,
    offerdoj: myResume?.offerdetails.offerdoj,
    whyjoinus: myResume?.offerdetails.whyjoinus,
    aadharnumber: myResume?.personaldetail.aadharid,
    uannumber: myResume?.personaldetail.uan,
    otherremarks: myApplication?.newemploymentdetails.otherremarks,
    dob: myResume?.personaldetail.dob,
    gender: myResume?.personaldetail.gender,
  };

  return (
    <div className="candidate-profile-summary-wrapper">
      <div className="profile-creation-form-wrapper">
        <div style={{ textAlign: "center" }}>My Profile - {appvalues.name}</div>
        <div className="header">
          <h5 className="jd-creation-form-title"> {resumeID} </h5>
        </div>

        <Form
          key={formKey}
          className="profile-creation-form"
          name="profile-creation-form"
          justify="start"
          layout="vertical"
          autoComplete="off"
          onFinish={value ? handleFormSubmit : handleFormSubmitError}
          initialValues={appvalues}
        >
          <div className="triple-input-wrapper">
            <Form.Item
              required={value ? false : true}
              className="jd-creation-field-item"
              label="Candidate Name"
              name="name"
            >
              <Input
                disabled={!isEditMode}
                required={value ? false : true}
                className="jd-creation-input"
              />
            </Form.Item>

            <Form.Item
              required={value ? false : true}
              className="jd-creation-field-item"
              label="Email ID"
              name="email"
            >
              <Input
                disabled={!isEditMode}
                required={value ? false : true}
                className="jd-creation-input"
              />
            </Form.Item>
            <Form.Item
              required={value ? false : true}
              name="mobile"
              className="jd-creation-field-item"
              label="Mobile Number"
            >
              <Input
                disabled={!isEditMode}
                required={value ? false : true}
                className="jd-creation-input"
              />
            </Form.Item>
          </div>

          <div className="triple-input-wrapper">
            <Form.Item
              required={isRequired}
              name="currentlocation"
              className="jd-creation-field-item"
              label="Current Location"
            >
              <Input
                disabled={!isEditMode}
                required={isRequired}
                className="jd-creation-input"
              />
            </Form.Item>

            <Form.Item
              required={isRequired}
              name="preferredlocation"
              className="jd-creation-field-item"
              label="Preferred Locations"
            >
              <Select
                disabled={!isEditMode}
                mode="multiple"
                allowClear
                required={value ? false : true}
                className="jd-creation-input"
                options={SUPPORTED_LOCATION}
              />
            </Form.Item>

            <Form.Item
              required={isRequired}
              name="locationchangereason"
              className="jd-creation-field-item"
              label="Relocation Reason"
            >
              <Select
                disabled={!isEditMode}
                placeholder="Please Select"
                required={isRequired}
                className="jd-creation-input"
                options={[
                  { value: "NA", label: "NA" },
                  { value: "Partner Job", label: "Partner Job" },
                  {
                    value: "Family Member Lives there",
                    label: "Family Member Lives there",
                  },
                  { value: "Carrer Growth", label: "Carrer Growth" },
                  { value: "Other Reasons", label: "Other Reasons" },
                ]}
              />
            </Form.Item>
          </div>

          <div className="triple-input-wrapper">
            <Form.Item
              required={isRequired}
              name="designation"
              className="jd-creation-field-item"
              label="Current Designation"
            >
              <Input
                disabled={!isEditMode}
                type="text"
                required={isRequired}
                className="jd-creation-input"
              />
            </Form.Item>

            <Form.Item
              required={isRequired}
              className="jd-creation-field-item"
              label="Total Exp (Yrs)"
              name="totalexp"
            >
              <Input
                disabled={!isEditMode}
                type="number"
                placeholder={"x.y"}
                required={isRequired}
                className="jd-creation-input"
                name="totalexp"
              />
            </Form.Item>

            <Form.Item
              required={isRequired}
              className="jd-creation-field-item"
              label="Relevant Exp (Yrs)"
              name="relevantexperience"
            >
              <Input
                disabled={!isEditMode}
                type="number"
                placeholder={"x.y"}
                required={isRequired}
                className="jd-creation-input"
              />
            </Form.Item>
          </div>

          <div className="triple-input-wrapper">
            <Form.Item
              required={isRequired}
              name="currentcompany"
              className="jd-creation-field-item"
              label="Current Company"
            >
              <Input
                disabled={!isEditMode}
                type="text"
                required={isRequired}
                className="jd-creation-input"
              />
            </Form.Item>
            <Form.Item
              required={isRequired}
              name="currentctc"
              className="jd-creation-field-item"
              label="Current CTC (LPA)"
            >
              <Input
                disabled={!isEditMode}
                type="text"
                required={isRequired}
                className="jd-creation-input"
              />
            </Form.Item>
            <Form.Item
              required={isRequired}
              name="ectc"
              className="jd-creation-field-item"
              label="ECTC (LPA)"
            >
              <Input
                disabled={!isEditMode}
                type="text"
                required={isRequired}
                className="jd-creation-input"
              />
            </Form.Item>
          </div>

          <div className="triple-input-wrapper">
            <Form.Item
              required={isRequired}
              name="ectcoptions"
              className="jd-creation-field-item"
              label="ECTC Options"
            >
              <Radio.Group
                disabled={!isEditMode}
                className="jd-creation-radio-wrapper-3"
              >
                <Radio className="radio-option" value={"Negotiable"}>
                  Negotiable
                </Radio>
                <Radio className="radio-option" value={"Fixed"}>
                  Fixed
                </Radio>
                <Radio className="radio-option" value={"Will Discuss with HR"}>
                  Will discuss with HR
                </Radio>
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="ctcremarks"
              className="jd-creation-field-item"
              label="CTC Remarks"
            >
              <Input
                disabled={!isEditMode}
                type="text"
                className="jd-creation-input"
              />
            </Form.Item>
            <Form.Item
              required={isRequired}
              className="jd-creation-field-item"
              label="Official Notice Period (Days)"
              name="noticeperiod"
            >
              <Select
                disabled={!isEditMode}
                placeholder="Please select"
                required={isRequired}
                className="jd-creation-input"
                options={[
                  { value: 0, label: 0 },
                  { value: 15, label: 15 },
                  { value: 30, label: 30 },
                  { value: 45, label: 45 },
                  { value: 60, label: 60 },
                  { value: 90, label: 90 },
                  { value: 120, label: 120 },
                  { value: 180, label: 180 },
                ]}
              />
            </Form.Item>
          </div>
          <div className="triple-input-wrapper">
            <Form.Item
              required={isRequired}
              className="jd-creation-field-item"
              label="Negotiable Notice Period (Days)"
              name="negotiablenoticeperiod"
            >
              <Select
                disabled={!isEditMode}
                placeholder="Please select"
                required={isRequired}
                className="jd-creation-input"
                options={[
                  { value: 0, label: 0 },
                  { value: 5, label: 5 },
                  { value: 10, label: 10 },
                  { value: 15, label: 15 },
                  { value: 30, label: 30 },
                  { value: 45, label: 45 },
                  { value: 60, label: 60 },
                  { value: 90, label: 90 },
                  { value: 120, label: 120 },
                  { value: 180, label: 180 },
                ]}
              />
            </Form.Item>
            <Form.Item
              className="jd-creation-field-item"
              label="LWD"
              name="lwd"
            >
              <Input
                disabled={!isEditMode}
                type="text"
                placeholder={"dd/mm/yyyy"}
                className="jd-creation-input"
              />
            </Form.Item>
            <Form.Item
              required={value ? false : true}
              className="jd-creation-field-item"
              label="Reason for Leaving "
              name="reason"
            >
              <Select
                disabled={!isEditMode}
                placeholder="Please select"
                required={isRequired}
                className="jd-creation-input"
                options={reasonForLeavingFilter}
              />
            </Form.Item>
          </div>

          <div className="triple-input-wrapper">
            <Form.Item
              name="uannumber"
              className="jd-creation-field-item"
              label="UAN Number"
            >
              <Input disabled={!isEditMode} className="jd-creation-input" />
            </Form.Item>
            <Form.Item
              name="aadharnumber"
              className="jd-creation-field-item"
              label="Aadhar Number"
            >
              <Input disabled={!isEditMode} className="jd-creation-input" />
            </Form.Item>
            <Form.Item
              name="dob"
              className="jd-creation-field-item"
              label="DoB"
            >
              <Input
                disabled={!isEditMode}
                className="jd-creation-input"
                placeholder="dd/mm/yyyy"
              />
            </Form.Item>
          </div>
        </Form>
      </div>
    </div>
  );
}
